/**
 * @file
 * Author: Synapse-studio.
 */

'use strict';

var $searchBlock = $('.blog-search');
var $resultBlock = $searchBlock.find('.blog-search-result');
var searchUrl = '/blog/quick-search';
var fieldIsResponsive = true;
var timer = 0;
$(document).ready(function() {
  search();
});

function search() {
  $searchBlock.find('.blog-search-field-input').on('keyup', function() {
    var fieldValue = $(this).val();
    if (fieldValue.length > 3) {
      fieldIsResponsive = false;
      typewatch(function() {
        sendData(fieldValue);
      }, 500);
    }
    else {
      clearTimeout(timer);
      clearField();
    }
  });
}
var typewatch = (function() {
  return function(callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

function sendData(fieldValue) {
  $.ajax({
    type: 'GET',
    url: searchUrl,
    data: {
      'search': fieldValue
    },
    success: function(input) {
      if (input) {
        $resultBlock.html(input);
        $resultBlock.addClass('blog-search-result--is-visible');
      }
      else {
        clearField();
      }
    }
  });
}

function clearField() {
  $resultBlock.html('');
  $resultBlock.removeClass('blog-search-result--is-visible');
}
